import React, { useEffect, useRef, useState } from 'react'

export default function GoaVideo() {
  const videoWrapRef = useRef(null);
  const [shouldLoadVideo, setShouldLoadVideo] = useState(false);
  const videoUrl = "https://www.youtube.com/embed/Y0bS9jMzZYg?si=WQeUgRkcJze8Uz2m";

  useEffect(() => {
    if (shouldLoadVideo) return;

    const videoWrap = videoWrapRef.current;
    if (!videoWrap || typeof IntersectionObserver === "undefined") {
      setShouldLoadVideo(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldLoadVideo(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(videoWrap);

    return () => observer.disconnect();
  }, [shouldLoadVideo]);

  return (
    <>
    <section className="goapage-video">
        <div className="container">
            <div className="row">

                <div className="col-lg-12" ref={videoWrapRef}>
                    <iframe src={shouldLoadVideo ? videoUrl : undefined} loading="lazy" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                </div>

            </div>
        </div>
    </section> 
    </>
  )
}
